<template>
	<div id="qs_right2">
		<div class="cc-header">体质健康</div>
		<div class="main-value" id="school_ad"></div>
	</div>
</template>

<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
const echarts = require("echarts");
export default {
	data() {
		return {
			total_count: 0
		};
	},
	mounted() {
		this.initData();
		// 定时器刷新，1小时
		let _this = this;
		this.interval = setInterval(() => {
			_this.initData();
		}, 1000 * 60 * 60);
	},
	beforeDestroy() {
		clearInterval(this.interval);
	},
	methods: {
		initData() {
			// 基于准备好的dom，初始化echarts实例
			let sportResultChart = echarts.init(document.getElementById("school_ad"));
			this.$http.get("/dataView/quality/getSportResult?orgCode=" + orgCode).then(res => {
				if (res.data.code === 200) {
					var result = res.data.result;
					var option = {
						tooltip: {
							trigger: 'item',
							formatter: function (params) {
								var relVal = '体测成绩<br/>' + params.marker + '&nbsp;' + params.name + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>' + params.value + '</b>人';
								return relVal
							}
						},
						legend: {
							bottom: 5,
							textStyle: {
								fontSize: fontSize(0.15),
								height: 13,
								rich: { a: { verticalAlign: 'middle' } },
								color: '#d3d6ff' // 把颜色这里做成函数就可以了
							},
							itemWidth: 20,
							itemHeight: 13
						},
						series: [{
							name: '体质健康',
							type: 'pie',
							radius: '55%',
							data: [{
								value: result.yx,
								name: '优秀',
								itemStyle: {
									color: '#ff8789'
								}
							},
							{
								value: result.lh,
								name: '良好',
								itemStyle: {
									color: '#7e4bff'
								}
							},
							{
								value: result.jg,
								name: '及格',
								itemStyle: {
									color: '#bc81ff'
								}
							},
							{
								value: result.bjg,
								name: '不及格',
								itemStyle: {
									color: '#55aaff'
								}
							}
							],
							labelLine: {
								normal: {
									smooth: 0.2,
									length: 15,
									length2: 10
								}
							},
							label: {
								normal: {
									padding: [0, 0], //文字和图的边距
									textStyle: {
										color: '#d3d6ff',
										lineHeight: 18,
										fontSize: fontSize(0.15)
									},
									formatter: ' {b} \n {c}人 '
								}
							}
						}]
					};
					sportResultChart.setOption(option);
					// 响应式变化
					window.addEventListener("resize", () => sportResultChart.resize(), false);
				}
			});
		}
	},
	destroyed() {
		window.onresize = null;
	}
};

function fontSize(res) {
	let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	if (!clientWidth) return;
	let fontSize = 100 * (clientWidth / 1920);
	return res * fontSize;
}
</script>

<style lang="scss">
#qs_right2 {
	height: 100%;
	padding: 0 2%;

	.cc-header {
		width: 100%;
		padding-top: 0.3rem;
		color: #55ffff;
		font-size: 0.3rem;
		text-align: center;
	}

	@media screen and (min-width: 768px) and (max-width: 992px) {
		.cc-header {
			height: 20%;
		}

		.main-value {
			height: 75%;
		}

		.title_tab {
			top: 0.4rem;
		}
	}

	@media screen and (min-width: 1200px) and (max-width: 1920px) {
		.cc-header {
			height: 15%;
		}

		.main-value {
			height: 80%;
		}

		.title_tab {
			top: 0.25rem;
		}
	}
}
</style>
